interface IGetExtendedOffersOffsetParameters {
  pageNumber: number;
  perPage: number;
  previousSuggestionsCount: number;
}

export function getExtendedOffersOffset({
  pageNumber,
  perPage,
  previousSuggestionsCount,
}: IGetExtendedOffersOffsetParameters): number {
  return (pageNumber - 1) * perPage - previousSuggestionsCount;
}
